module.exports = __webpack_public_path__ + "img/medications.ca7c7e61.svg";